import React, { useState } from "react";

// Remove the import for AlertContext
// import AlertContext from './AlertContext';

// Instead, you can directly import the AlertContext from the file where it is created and exported
import SocketContext from "./SocketContext";

const SocketState = (props) => {
  const [OnlineUsers, setOnlineUsers] = useState([]);
  const [SocetConnection, setSocetConnection] = useState(null);

  const settingOnlineUsers = (User) => {
    setOnlineUsers([...OnlineUsers, User]);
  };

  const isUserOnline = (userId) => OnlineUsers?.includes(userId);

  return (
    <SocketContext.Provider
      value={{
        OnlineUsers,
        settingOnlineUsers,
        setOnlineUsers,
        setSocetConnection,
        SocetConnection,
        isUserOnline,
      }}
    >
      {props.children}
    </SocketContext.Provider>
  );
};

export default SocketState;
